export enum NavigationPath {
  Home = '/',
  Intro = '/intro',
  QuizIntro = '/quiz/intro',
  QuizQuestion = '/quiz/:id',
  PersonalGrowth = '/personal-growth',
  FinancialIQ = '/financial-iq',
  Email = '/email',
  GrowthPlan = '/growth-plan',
  QuizResult = '/quiz/result',

  AdultHome = '/adult',
  AdultIntro = '/adult/intro',
  AdultQuizIntro = '/adult/quiz/intro',
  AdultQuizQuestion = '/adult/quiz/:id',
  AdultFinancialIQ = '/adult/financial-iq',
  AdultEmail = '/adult/email',
  AdultQuizResult = '/adult/quiz/result',
}

export interface ScreenProps {
  type: 'parent' | 'adult';
}
